<template>
  <div class="">
    <keep-alive>
      <div class="main-container">
        <breadcrumb :list="breadcrumbList" />
        <br />
        <tl-header type="h1">
          <div class="main-header margintop-10">FBP Declaration</div>
        </tl-header>
        <div>
          <div class="searchclass margin-bot-22">
            <div
              class="permission-alert-msg"
              v-show="!ifTeamleaderAnchorPermission"
            >
              You have only view permission.
            </div>
            <div class="permission-alert-msg" v-show="showErrorMsg">
              Monthly declaration amount must be lesser than monthly eligibility
              value.
            </div>
            <div class="permission-alert-msg" v-show="showErrorMsgs">
              Negative values are not allowed.
            </div>
            <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
            <div class="uploadMethoRadio">
              <tl-radio
                name="uploadType"
                label="Manual Select Employee's"
                id="manualUpload"
                value="manualUpload"
                v-model="uploadMethod"
              />
              <tl-radio
                name="uploadType"
                label="Bulk Upload Employee's Details"
                id="bulkUpload"
                value="bulkUpload"
                v-model="uploadMethod"
              />
            </div>
            <div
              class="block-width-no-use"
              :disabled="!ifTeamleaderAnchorPermission"
              v-if="uploadMethod == 'manualUpload'"
            >
              <search-dropdown
                v-if="!showEmpDetails"
                placeholder="Search Employee"
                :employeeData="employeeData"
                :clearRequired="true"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp) => selectedEmp(emp)"
              />
            
            <!-- <selected-employee-card
              v-if="showEmpDetails"
              :empName="data.first_name"
              :joiningDate="showJoiningDate"
              showJoiningDate=false
              :currCTC="ctcAmount"
              :empId="data.code"
              :dates="data.rlopdates"
              :empMail="data.email_id"
              @click="refresh()"
            >
              <template v-slot:rowcontent=""></template>
            </selected-employee-card> -->
            <div v-if="showEmpDetails" class="employeeCard">
              <div class="empImage">
                <img
                  :src="data.photo_url"
                  class="employeeImage"
                  alt=""
                  v-if="data.photo_url"
                />
                <img
                  src="@/assets/user.svg"
                  class="employeeImage"
                  alt=""
                  v-if="!data.photo_url"
                />
              </div>
              <div class="employeeDetails">
                <div class="rowOneContent">
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Name:</p>
                      <p class="empContent">
                        <b>{{ data.first_name }}</b>
                      </p>
                    </div>
                  </div>
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">CTC:</p>
                      <p class="empContent">
                        <b>{{ formate.format(ctcAmount) }}</b>
                      </p>
                    </div>
                  </div>
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Effective Date:</p>
                      <p class="empContent">
                        <b>{{ effectiveDate}}</b>
                      </p>
                    </div>
                  </div>
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Monthly {{ specialAllowanceLabel }}:</p>
                      <p class="empContent">
                        <b>{{ formate.format(monthltSpecialAllowance) }}</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="rowOneContent">
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Employee Code:</p>
                      <p class="empContent">
                        <b>{{ data.code }}</b>
                      </p>
                    </div>
                  </div>
                  <!-- <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Unallocated FBP :</p>
                      <p class="empContent">
                        <b>{{formate.format(unAllocatedFbp)}}</b>
                      </p>
                    </div>
                  </div> -->
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent"> Pro-rated {{ specialAllowanceLabel }}:</p>
                      <p class="empContent">
                        <b>{{formate.format(specialAllowance)}}</b>
                      </p>
                    </div>
                  </div>
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent">Balance {{ specialAllowanceLabel }} Monthly:</p>
                      <p class="empContent">
                        <b>{{ formate.format(monthltSpecialAllowanceDeclared) }}</b>
                        <span :title="`Balance ${specialAllowanceLabel} Monthly = (Pro-rated ${specialAllowanceLabel} - Total FBP Declared - ${specialAllowanceLabel} paid till last month) / Remaining number of months (including current payroll)`" class="tooltip">
                        ℹ️
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="empDetails">
                    <div class="empContentdev">
                      <p class="empContent"> {{ specialAllowanceLabel }} Paid till Date :</p>
                      <p class="empContent">
                        <b>{{formate.format(this.fbpAllocationDetails instanceof Array ? this.fbpAllocationDetails[this.fbpAllocationDetails.length-1].spAllowancePaidTillDate:this.fbpAllocationDetails.spAllowancePaidTillDate)}}</b>
                      </p>
                    </div>
                  </div>
                  <!-- <div class="empDetails">
          <div class="amountHeading">Special Allowance Paid till Date :</div>
        </div> -->
              </div>  
              </div>
              <tl-checkbox
                     class="checkbox"
                     label="FBP Declaration Lock"
                     :checked="is_employee_submitted"
                     @change="(val) => (is_employee_submitted = val)"
                  ></tl-checkbox>
            </div>
          
          <data-table
            v-if="showEmpDetails && fetchingBack"
            :columns="employeeTable"
            :tableData="newArrayElementData"
            class="custom-data"
            :checkbox="false"
            :withForm="false"
            :showinrow="true"
            @editStart="false"
            :showedit="false"
            :showdelete="false"
            :showhistory="false"
          >
            <template v-slot:rowcontent="slotprops">
              <p v-if="slotprops.value.column.key == 'salaryComponentLEName'">
                {{ slotprops.value.record.salaryComponentLEName }}
              </p>
              <p style="text-align:right;" v-if="slotprops.value.column.key == 'value'">
                {{ formateLess.format(slotprops.value.record[slotprops.value.column.key]) }}
              </p>
              <p style="text-align:right;" v-if="slotprops.value.column.key == 'yearly_eligibility'">
                {{ formateLess.format(slotprops.value.record.yearly_eligibility) }}
              </p>
              <txt
                id="monthly"
                v-if="
                  slotprops.value.column.key == 'monthly_declaration_amount'
                "
                class="custom"
                autofocus="true"
                v-model="slotprops.value.record[slotprops.value.column.key]"
                @change="
                  (val) =>
                    saveValuesFor(
                      slotprops.value.record[slotprops.value.column.key],
                      slotprops.value,
                      'monthly_declaration_amount'
                    )
                "
                @blur="saveValuesFecthing(slotprops.value.record)"
              />
              <txt
                disable
                v-if="slotprops.value.column.key == 'annual_declared_amount'"
                class="custom"
                v-model="slotprops.value.record.annual_declared_amount"
              />
            </template>
          </data-table>
          <data-table
            v-if="showEmpDetails && gettingNew"
            :columns="employeeTableColumns"
            :tableData="fbpCtcSlabscomponents"
            class="custom-data"
            :checkbox="false"
            :withForm="false"
            :showinrow="false"
            @editStart="false"
            :showedit="false"
            :showdelete="false"
            :showhistory="false"
          >
            <template v-slot:rowcontent="slotprops">
              <p v-if="slotprops.value.column.key == 'salaryComponentLEName'">
                {{ slotprops.value.record.salaryComponentLEName }}
              </p>
              <p style="text-align:right;" v-if="slotprops.value.column.key == 'value'">
                {{ formateLess.format(slotprops.value.record[slotprops.value.column.key]) }}
              </p>
              <p style="text-align:right;" v-if="slotprops.value.column.key == 'yearly_eligibility'">
                {{ formateLess.format (slotprops.value.record.yearly_eligibility) }}
              </p>
              <txt
                v-if="
                  slotprops.value.column.key == 'monthly_declaration_amount'
                "
                class="custom"
                v-model="slotprops.value.record[slotprops.value.column.key]"
                @change="
                  (val) =>
                    saveValues(
                      slotprops.value.record[slotprops.value.column.key],
                      slotprops.value,
                      'monthly_declaration_amount'
                    )
                "
                @blur="updateComponent(slotprops.value.record)"
              />
              <txt
                v-if="slotprops.value.column.key == 'annual_declared_amount'"
                class="custom"
                disable
                v-model="slotprops.value.record.annual_declared_amount"
              />
            </template>
          </data-table>
        </div>
      </div>
          <div v-if="uploadMethod == 'bulkUpload'">
            <div class="download-btn marginbot-20">
              <download-button @downloadTemplate="downloadTemplate" >
                </download-button>
            </div>
            <div class="margin-t-15px" :key="componentKey">
              <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
            </div>
          </div>
          <pop-up-message
            v-if="showSuccessMsg"
            :message="`FBP Declaration has been successfully created`"
            btnText="Back"
            @back="backFromPopUp()"
          />
        </div>
        <footer>
          <bottom-action-container>
            <template slot="end">
              <btn-grp class="form-button" v-if="showButtons">
                <btn
                  :disabled="showErrorMsg"
                  text="cancel"
                  type="secondary"
                  @click="refresh"
                />
                <btn
                  :disabled="showErrorMsg"
                  :text="submitFormText"
                  type="primary"
                  @click="submit"
                />
              </btn-grp>
            </template>
          </bottom-action-container>
        </footer>
      </div>
      <pop-up-message
        v-if="showErrorPopup"
        message=""
        popupType="Warning"
        :popupHeaderMessage="'UPLOAD FAILED!!!'"
      >
          <template v-slot:bottomContent>
            <div style="margin-top: -70px;">
              <div class="margintop-32">
                  <span style="font-size: 1.2rem;">{{ logMessage }}</span>
              </div>
              <div class="margintop-32 custom-container">
                <a :href="logSheetUrl"
                  @click="downloadItem(logSheetUrl)"
                ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
              </div>
            </div>
            <div class=" margintop-32 marginright" style="display: flex; justify-content: end;">
              <button class="btn-popup" type="button" @click="backfromlogpopup()">Back</button>
            </div>
          </template>
      </pop-up-message>
    </keep-alive>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "ManageEmployeeDocuments",
  components: {
    SearchDropdown,
    selectedEmployeeCard,
  },
  props: {
    showdocumentupload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      payrollDetails:{},
      fbpAllocationDetails: {},
      breadcrumbList: [
        {
          name: "HR",
          url: `/dashboard/${this.$route.params.entity_index}/HumanResorces`,
        },
        {
          name: "FBP",
          url: `/dashboard/${this.$route.params.entity_index}/HumanResorces/FBP`,
        },
        {
          name: "FBPDeclaration",
          url: `/dashboard/${this.$route.params.entity_index}/HumanResorces/declarationFBP`,
        },
      ],
      formate: "",
      formateLess:"",
      monthltSpecialAllowance: "",
      monthltSpecialAllowanceDeclared: "",
      showButtons: false,
      is_employee_submitted: false,
      toast: false,
      effectiveDate: "",
      newArrayElementData: [],
      showErrorMsg: false,
      showErrorMsgs: false,
      elementFbpComponentId: [],
      fbp_salary_grade_id: "",
      fbp_level_id: "",
      fbp_location_id: "",
      catagoryName: "",
      fetchedId: "",
      fbpSalaryId: "",
      slabIdFetced: "",
      totol: "100",
      fetchingBack: false,
      gettingNew: false,
      employeeDocs: [],
      fbpCtcSlabscomponentsandvalue: [],
      fbpCtcSlabscomponents: [],
      levelId: [],
      gradeId: [],
      locationIdOf: "",
      subRepTypeOption: [],
      uploadMethod: "manualUpload",
      showEmpDetails: false,
      data: {},
      count: 0,
      showPopup: false,
      specialAllowance: "",
      showUploadDocuments: false,
      showFullDocuments: false,
      popUpHeaderTitle: "",
      popUpHeaderFileName: "",
      employeeData: [],
      financialdates: new Date(),
      componentList: [],
      empId: null,
      selectedIndex: 0,
      showSuccessMsg: false,
      fullDocument: null,
      uploadDocument: null,
      viewDocument: null,
      le: null,
      monthly_declaration_amount: [],
      sum: [],
      fbp_ctc_slab_id: "",
      showJoiningDate: "",
      unAllocatedFbp: "",
      ctcAmount: "",
      showErrorPopup:false,
      logMessage: null,
      employeeTable: [
        {
          label: "FBP Components",
          key: "salaryComponentLEName",
        },
        {
          label: "Monthly Eligibility(₹)",
          key: "value",
          style: 'text-align:right',
        },
        {
          label: "Yearly Eligibility(₹)",
          key: "yearly_eligibility",
          style: 'text-align:right',
        },
        {
          label: "Monthly Declaration(₹)",
          key: "monthly_declaration_amount",
        },
        {
          label: "Annual Declaration(₹)",
          key: "annual_declared_amount",
        },
      ],
      employeeTableColumns: [
        {
          label: "FBP Components",
          key: "salaryComponentLEName",
        },
        {
          label: "Monthly Eligibility(₹)",
          key: "value",
          style: 'text-align:right',
        },
        {
          label: "Yearly Eligibility(₹)",
          key: "yearly_eligibility",
          style:'text-align:right',
        },
        {
          label: "Monthly Declaration(₹)",
          key: "monthly_declaration_amount",
        },
        {
          label: "Annual Declaration(₹)",
          key: "annual_declared_amount",
        },
      ],

      companyValue: false,
      role: "",
      slab_id_new: "",
      componentKey: 0,
    };
  },
  mounted() {
    this.getLocations();
    this.fetchAll();
    this.fetchAllLevelId();
    this.fetchAllGradeId();
    this.editForm = true;
    this.showSuccessMsg = false;
    this.getPayrollDetails();
    this.getOrgLeIdList();
  },

  activated() {
    this.getLocations();
    this.getPayrollDetails();
    this.toast = false;
    this.errmsg = "";
    this.editForm = true;
    this.showSuccessMsg = false;
    this.le = this.leId();
    this.getOrgLeIdList();
  },

  computed: {
    ...mapState("onboard/ctcslab", {
      ctcSlabsDataAll: (state) => state.entityWiseData,
    }),
    ...mapState({
      globalEmployeeList: (state) =>
        state.globalapi.globalemployees.entityWiseData,
    }),
    ...mapState("dashboard/humanResource/fbpdeclaration", {
      FBPSlabsDataAll: (state) => state.entityWiseData,
      isFetching: (state) => state.isFetching,
      isSaving: (state) => state.isSaving,
      isDeleting: (state) => state.isDeleting,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapGetters("onboard/legal_entities", {
      legalEntity: "record",
    }),
    ...mapGetters("onboard/fbpEligibilityConfig", {
      legalEntityss: "record",
      editForm: "editMode",
    }),

    leId() {
      //console.log("inside the leId");
      this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
      
    },

    submitFormText() {
      if (this.fetchingBack) {
        return "Update";
      } else {
        return "Save";
      }
    },

    CTCslabID() {
      //console.log(this.leId);
      return this.ctcSlabsDataAll[this.leId];
    },
    requestParams() {
      return {
        leId: this.leId,
      };
    },
    ...mapState("onboard/organization", {
      orgId: (state) => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" ||
        this.role === "ADMIN"
      ) {
        if (this.companyValue) {
          return true;
        } else {
          return false;
        }
      }
    },
    specialAllowanceLabel() {
      const pdaEntities = [
        'dfba4011-0c5e-46cc-b4f4-99f5962f9ebe',
        'ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0'
      ];
      const hraEntities = [
        'eeddce5f-655a-4527-8cf1-a408f44fbad7',
        'b194b460-1197-4304-83e0-60eebe7fe956',
        'e72b1b01-d798-4afd-9b6e-88285d1bbaed'
      ];
      if (pdaEntities.includes(this.leId)) return 'Professional Development Allowance';
      if (this.leId === '98d4b7fe-9444-4f65-9d12-155eeffab56a') return 'Conveyance';
      if (hraEntities.includes(this.leId)) return 'HRA';
      return 'Special Allowance';
    },
  },

  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetchEmployeeDocumentsByEmployeeId:
        "dashboard/organisation/employeeDocument/fetchEmployeeByID",
      act_getFBP_component:
        "dashboard/humanResource/fbpdeclaration/fetchingfbpslabcomponent",
      act_postFBP_declare: "dashboard/humanResource/fbpdeclaration/create",
      act_getFbp_declare: "dashboard/humanResource/fbpdeclaration/fetchAll",
      act_getFbp_componentliost:
        "dashboard/humanResource/fbpdeclaration/fetchFBP_component",
      act_fetch_locations: "onboard/locations/fetchAll",
      act_get_current_payroll_details: 'dashboard/payroll/monthlypayroll/lockPayroll/getCurrentPayrollDetails',
      act_download_declare_template: "dashboard/humanResource/fbpdeclaration/getDeclarationTemplate",
      act_upload_declare_template: "dashboard/humanResource/fbpdeclaration/fbpDeclarationUploadTemplate",
      act_fetchAllSpecialAllowance: "dashboard/humanResource/fbpDeclarationEss/fetchAll",

    }),
    ...mapActions("onboard/levels/", {
      act_fetchAllforlevelid: "fetchAll",
    }),
    ...mapActions("onboard/ctcslab/", {
      act_fetchAll: "fetchAll",
    }),
    ...mapActions("onboard/salary_grades/", {
      act_fetchAllforgradeid: "fetchAll",
    }),

    async searchEmployeesByName(val) {
      try {
        //console.log("i am called when click particular employee");
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.leId,
          key: val,
        });
        this.employeeData = res.data.payload;
        // this.empId = res.data.payload[0].id;
        //console.log("i am empId", this.empId);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async fetchAllForSpecialAllowancePaidTillDate(){
      try {
        let payload ={
          le_id: this.leId,
          employee_id: this.empId,
        }
        let res = await this.act_fetchAllSpecialAllowance(payload)
        this.fbpAllocationDetails = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getPayrollDetails(){
      try {
        let res = await this.act_get_current_payroll_details(this.leId)
        this.payrollDetails = res.data.payload.data;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async downloadTemplate() {
      try {
        let payload = {
          le_id: this.leId,
        }
        let res = await this.act_download_declare_template(payload);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

   async onUploadTemplate(event) {
      //   let currentMonthEnum = this.financialMonthOptions.find(
      //   item => item.name == this.monthOptions[new Date().getMonth()]
      // ).value;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.leId);
      formData.append(
        "fbp_year",
        this.payrollDetails.year
      );

      this.$root._data.isSaving = true;
      try {
        let res = await this.act_upload_declare_template(formData);
        if (res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          // this.$refs.bulkFile.uploaded = true;
          // this.$refs.bulkFile.uploading = false;
          this.showSuccessBulkUploadMsg = true;
          this.showSuccessMsg = true;
          this.showErrorPopup = false;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        // this.showSuccessBulkUploadMsg = true;
        this.showSuccessMsg = false;
        this.showErrorPopup = true;
        this.logMessage = err.message;
        this.logSheetUrl = err.payload.data;
      }
    },

    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },

    saveValues(val, data, key) {
      let record = data.record
      if(val<0 || val=="-"){
        this.showErrorMsg = false;
        this.showErrorMsgs  = true;
      }
      else if (record.value >= record.monthly_declaration_amount) {
        this.showErrorMsg = false;
        this.showErrorMsgs = false;
        record[key] = val ? Number(val) : val;
        let noOfMonths;
        if (record.remainingDays == 0) {
          noOfMonths = record.remainingMonth;
        } else {
          noOfMonths = record.remainingMonth - 1;
        }
        let annualDeclaredAmount = val
          ? (Number(val) / record.noOfDaysInMonth) * record.remainingDays +
            Number(val) * noOfMonths
          : val; 
          let indexOfDisplay = data.index;
          this.fbpCtcSlabscomponents[indexOfDisplay].annual_declared_amount = annualDeclaredAmount;
          record.annual_declared_amount = annualDeclaredAmount
        const index = this.fbpCtcSlabscomponents.findIndex(
          (i) => i.fbp_component_id === record.fbp_component_id
        );
        if (index > -1) {
          this.fbpCtcSlabscomponents[index][key] = val ? Number(val) : val;
          let annualDeclaredAmount = val
            ? (Number(val) / record.noOfDaysInMonth) * record.remainingDays +
              Number(val) * noOfMonths
            : val;
            this.fbpCtcSlabscomponents[index].annual_declared_amount = annualDeclaredAmount.toFixed(2)
        }
      } else {
        //console.log("i am greater");
        this.showErrorMsg = true;
      }
    },
    saveValuesFor(val, data, key) {
      let record = data.record
      if(val<0 || val=="-"){
        this.showErrorMsg = false;
        this.showErrorMsgs  = true;
      }
      else if (record.value >= record.monthly_declaration_amount) {
        this.showErrorMsg = false;
        this.showErrorMsgs = false;
        let noOfMonths;
        if (record.remainingDays == 0) {
          noOfMonths = record.remainingMonth;
        } else {
          noOfMonths = record.remainingMonth - 1;
        }
        record[key] = val ? Number(val) : val;
        let annualDeclaredAmount = val
          ? (Number(val) / record.noOfDaysInMonth) * record.remainingDays +
            Number(val) * noOfMonths
          : val;
          let indexOfDisplay = data.index;
          console.log(this.newArrayElementData)
          this.newArrayElementData[indexOfDisplay].monthly_declaration_amount = val;
          this.newArrayElementData[indexOfDisplay].annual_declared_amount = annualDeclaredAmount;
          record.annual_declared_amount = Number(annualDeclaredAmount.toFixed(2))
        const index = this.fbpCtcSlabscomponents.findIndex(
          (i) => i.salaryComponentLEName === record.salaryComponentLEName
        );
        if (index > -1) {
          this.fbpCtcSlabscomponents[index][key] = val ? Number(val) : val;
          let annualDeclaredAmount = val
            ? (Number(val) / record.noOfDaysInMonth) * record.remainingDays +
              Number(val) * noOfMonths
            : val;
            this.fbpCtcSlabscomponents[index].annual_declared_amount = Number(annualDeclaredAmount.toFixed(2));
        }
      } else {
        //console.log("i am greater");
        this.showErrorMsg = true;
      }
    },

    updateComponent(record) {
      let isPresent = this.componentList.some(
        (x) => x.fbp_component_id === record.fbp_component_id
      );
      if (isPresent) {
        let index = this.componentList.findIndex(
          (x) => x.fbp_component_id === record.fbp_component_id
        );
        this.componentList[index].monthly_declaration_amount =
          record.monthly_declaration_amount;
          let annaulValue = record.annual_declared_amount && record.annual_declared_amount.toFixed(2);
        this.componentList[index].annual_declared_amount = Number(annaulValue)
        
          
      } else {
        this.componentList.push(record);
      }
      this.componentList = this.componentList.filter(item => item.monthly_declaration_amount > 0);
    },

    saveValuesFecthing(record) {
      let isPresent = this.componentList.some(
        (x) => x.salaryComponentLEName === record.salaryComponentLEName,
      );
      if (isPresent) {
        let index = this.componentList.findIndex(
          (x) => x.salaryComponentLEName === record.salaryComponentLEName
        );
        this.componentList[index].monthly_declaration_amount =
          record.monthly_declaration_amount;
          let annaulValue = record.annual_declared_amount && record.annual_declared_amount.toFixed(2);
        this.componentList[index].annual_declared_amount = Number(annaulValue)
        
      } else {
        this.componentList.push(record);
      }
      // this.componentList = this.componentList.filter(item => item.monthly_declaration_amount > 0);
    },

    async selectedEmp(emp) {
      try {
        this.employeeDocs = [];
        //console.log("empObj", emp);
        this.data = emp;
        this.empId = emp.id;
        this.fetchAllForSpecialAllowancePaidTillDate();
        let res = await this.fetchEmployeeDocumentsByEmployeeId({
          data: { employee_id: emp.id },
        });
        //console.log("enterd to selectedEMP", res,"this.data",this.data);
        this.loadEmployeeDocuments(res);
        this.showEmpDetails = true;
        this.fetchAllFbpLockDetails();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    // server call for fetchlevelid
    async fetchAllLevelId() {
      try {
        let res = await this.act_fetchAllforlevelid(this.leId);
        this.levelId = res.data.payload.data.map((user) => {
          return user.id;
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get grdaes */
    async fetchAllGradeId() {
      try {
        let res = await this.act_fetchAllforgradeid(this.leId);
        this.gradeId = res.data.payload.data.map((user) => {
          return user.id;
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get slabid */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.leId);
        // this.fbp_ctc_slab_id = res.data.payload[0].dep.id;
        // console.log(this.fbp_ctc_slab_id , "after");
        if (res && res.data && res.data.payload && res.data.payload.length > 0 && res.data.payload[0].dep) {
            this.fbp_ctc_slab_id = res.data.payload[0].dep.id;
        } 
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    // //server call to get employeedetailsfrom employee official
    // async fetchAll_Employeeofficial() {
    //   try {
    //     let res = await this.act_fetchEmpById(this.empId);
    //     let Ctc = 0;
    //     let Basic = 0;
    //     let DA = 0;
    //     let Hra = 0;
    //     let specialAllowance = 0;
    //     res.data.payload.data.EmployeeSalarySetting.map((element) => {
    //       Ctc = element.ctc;
    //       element.master_salary_structure.map((element) => {
    //         if (element.name == "Basic") {
    //           Basic = parseInt(element.monthly);
    //         } else if (element.name == "Dearness Allowance") {
    //           DA = parseInt(element.monthly);
    //         } else if (element.name == "House Rent Allowance") {
    //           Hra = parseInt(element.monthly);
    //         } else if (element.name == "Special Allowance") {
    //           specialAllowance = parseInt(element.monthly);
    //         } else {
    //           //console.log(element.name);
    //         }
    //       });
    //       //console.log("i am ctc", Ctc);
    //       //console.log("i am Basic", Basic);
    //       //console.log("i am DA", DA);
    //       //console.log("i am Hra", Hra);
    //       //console.log("i am specialAllowance", specialAllowance);
    //       //console.log(this.catagoryType);
    //     });

    //     if (this.catagoryType == "LOCATION") {
    //       this.gradeSlabLevelId =
    //         res.data.payload.data.EmployeeOfficial.based_location_id;
    //       let results = await this.act_getFBP_component({
    //         fbp_criterias: this.catagoryType,
    //         fbp_location_id: this.gradeSlabLevelId,
    //       });

    //       //console.log(results);
    //       results.data.payload.forEach((element) => {
    //         let eligibilityValue;
    //         if (element.calculation_type == "FLAT") {
    //           eligibilityValue = element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_CTC") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_BASIC") {
    //           eligibilityValue = (Basic / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_GROSS") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else {
    //           //console.log("else");
    //         }
    //         //console.log(eligibilityValue);
    //         //console.log(Math.round(eligibilityValue));
    //         //console.log(Number(Math.round(eligibilityValue)));
    //         this.fbpCtcSlabscomponents.push({
    //           salaryComponentLEName: element.SalaryComponentLegalEntity.name,
    //           annual_declared_amount:
    //             element.SalaryComponentLegalEntity.annual_declared_amount,
    //           monthly_declaration_amount:
    //             element.SalaryComponentLegalEntity.monthly_declaration_amount,
    //           value: Number(Math.round(eligibilityValue)),
    //           fbp_component_id: element.SalaryComponentLegalEntity.id,
    //         });
    //       });

    //       this.gettingNew = true;
    //       this.fetchingBack = false;
    //       for (let salaryId of results.data.payload) {
    //         this.fbpSalaryId =
    //           salaryId.fbp_salary_grade_id ||
    //           salaryId.fbp_level_id ||
    //           salaryId.fbp_location_id ||
    //           salaryId.fbp_ctc_slab_id;
    //       }
    //     } else if (this.catagoryType == "LEVEL") {
    //       this.gradeSlabLevelId =
    //         res.data.payload.data.EmployeeOfficial.level_id;
    //       let resultss = await this.act_getFBP_component({
    //         fbp_criterias: this.catagoryType,
    //         fbp_level_id: this.gradeSlabLevelId,
    //       });
    //       resultss.data.payload.forEach((element) => {
    //         let eligibilityValue;
    //         if (element.calculation_type == "FLAT") {
    //           eligibilityValue = element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_CTC") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_BASIC") {
    //           eligibilityValue = (Basic / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_GROSS") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else {
    //           //console.log("else");
    //         }
    //         this.fbpCtcSlabscomponents.push({
    //           salaryComponentLEName: element.SalaryComponentLegalEntity.name,
    //           annual_declared_amount:
    //             element.SalaryComponentLegalEntity.annual_declared_amount,
    //           monthly_declaration_amount:
    //             element.SalaryComponentLegalEntity.monthly_declaration_amount,
    //           value: Number(Math.round(eligibilityValue)),
    //           fbp_component_id: element.SalaryComponentLegalEntity.id,
    //         });
    //       });

    //       this.gettingNew = true;
    //       this.fetchingBack = false;
    //       for (let salaryId of resultss.data.payload) {
    //         this.fbpSalaryId =
    //           salaryId.fbp_salary_grade_id ||
    //           salaryId.fbp_level_id ||
    //           salaryId.fbp_location_id ||
    //           salaryId.fbp_ctc_slab_id;
    //       }
    //     } else if (this.catagoryType == "GRADES") {
    //       this.gradeSlabLevelId =
    //         res.data.payload.data.EmployeeOfficial.grade_id;
    //       let resultsss = await this.act_getFBP_component({
    //         fbp_criterias: this.catagoryType,
    //         fbp_salary_grade_id: this.gradeSlabLevelId,
    //       });
    //       //console.log("i am grade", resultsss);
    //       resultsss.data.payload.map((element) => {
    //         //console.log(element.calculation_type);
    //         let eligibilityValue;
    //         if (element.calculation_type == "FLAT") {
    //           eligibilityValue = element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_CTC") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_BASIC") {
    //           eligibilityValue = (Basic / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_GROSS") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else {
    //           //console.log("else");
    //         }
    //         this.fbpCtcSlabscomponents.push({
    //           salaryComponentLEName: element.SalaryComponentLegalEntity.name,
    //           annual_declared_amount:
    //             element.SalaryComponentLegalEntity.annual_declared_amount,
    //           monthly_declaration_amount:
    //             element.SalaryComponentLegalEntity.monthly_declaration_amount,
    //           value: Number(Math.round(eligibilityValue)),
    //           fbp_component_id: element.SalaryComponentLegalEntity.id,
    //         });
    //       });

    //       this.gettingNew = true;
    //       this.fetchingBack = false;
    //       for (let salaryId of resultsss.data.payload) {
    //         this.fbpSalaryId =
    //           salaryId.fbp_salary_grade_id ||
    //           salaryId.fbp_level_id ||
    //           salaryId.fbp_location_id ||
    //           salaryId.fbp_ctc_slab_id;
    //       }
    //     } else {
    //       //console.log(
    //         "i am enterd to if condition for because of ctcslab",
    //         res.data.payload.data.EmployeeOfficial.fbp_ctc_slab_id
    //       );
    //       this.gradeSlabLevelId =
    //         res.data.payload.data.EmployeeOfficial.fbp_ctc_slab_id;
    //       //console.log("slab ID--->",this.slab_id_new)
    //       let result = await this.act_getFBP_component({
    //         //fbp_ctc_slab_id: this.gradeSlabLevelId,  // comment old code for temporary
    //         fbp_ctc_slab_id: this.slab_id_new,
    //       });
    //       result.data.payload.forEach((element) => {
    //         let eligibilityValue;
    //         if (element.calculation_type == "FLAT") {
    //           eligibilityValue = element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_CTC") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_BASIC") {
    //           eligibilityValue = (Basic / 12 / 100) * element.value;
    //         } else if (element.calculation_type == "PERCENTAGE_OF_GROSS") {
    //           eligibilityValue = (Ctc / 12 / 100) * element.value;
    //         } else {
    //           //console.log("else");
    //         }
    //         this.fbpCtcSlabscomponents.push({
    //           salaryComponentLEName: element.SalaryComponentLegalEntity.name,
    //           annual_declared_amount:
    //             element.SalaryComponentLegalEntity.annual_declared_amount,
    //           monthly_declaration_amount:
    //             element.SalaryComponentLegalEntity.monthly_declaration_amount,
    //           value: Number(Math.round(eligibilityValue)),
    //           fbp_component_id: element.SalaryComponentLegalEntity.id,
    //         });
    //       });
    //       this.gettingNew = true;
    //       this.fetchingBack = false;
    //       for (let salaryId of result.data.payload) {
    //         this.fbpSalaryId =
    //           salaryId.fbp_salary_grade_id ||
    //           salaryId.fbp_level_id ||
    //           salaryId.fbp_location_id ||
    //           salaryId.fbp_ctc_slab_id;
    //       }
    //     }
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    // server call to get employeedetailsfrom employee official to store only value
    async fetchFBPcomponentlistonly_for_value() {
      try {
        //console.log("i am entered");
        this.showButtons=true;
        for (let i = 0; i < this.fbpCtcSlabscomponentsandvalue.length; i++) {
          this.newArrayElementData.push({
            salaryComponentLEName:
              this.fbpCtcSlabscomponentsandvalue[i].salaryComponentLEName,
            annual_declared_amount:
              this.fbpCtcSlabscomponentsandvalue[i].annual_declared_amount,
            monthly_declaration_amount:
              this.fbpCtcSlabscomponentsandvalue[i].monthly_declaration_amount,
            value: this.fbpCtcSlabscomponentsandvalue[i].value,
            yearly_eligibility:
              this.fbpCtcSlabscomponentsandvalue[i].yearly_eligibility,
            remainingMonth:
              this.fbpCtcSlabscomponentsandvalue[i].remainingMonth,
            remainingDays: this.fbpCtcSlabscomponentsandvalue[i].remainingDays,
            noOfDaysInMonth:
              this.fbpCtcSlabscomponentsandvalue[i].noOfDaysInMonth,
            effective_date:
              this.fbpCtcSlabscomponentsandvalue[i].effective_date,
            ctc: this.fbpCtcSlabscomponentsandvalue.ctc,
            date_of_joining: this.fbpCtcSlabscomponentsandvalue.date_of_joining,
            code: this.fbpCtcSlabscomponentsandvalue[i].code,
            pay_type: this.fbpCtcSlabscomponentsandvalue[i].pay_type
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    // //server call to fetch componentlist freshly
    // async fetchFBPcomponentlist() {
    //   try {
    //     this.catagoryType = "";
    //     this.fbpCtcSlabscomponents = [];
    //     let res = await this.act_getFbp_componentliost(
    //       {
    //         le_id: this.leId,
    //         emp_id: this.empId
    //       });
    //     //console.log("Before Get slab id---->",res.data.payload[0].fbp_ctc_slab_id);
    //     this.slab_id_new = res.data.payload[0].fbp_ctc_slab_id;
    //     //console.log("After Get slab id---->",this.slab_id_new);
    //     res.data.payload.forEach((element) => {
    //       this.catagoryType =
    //         element.fbp_criterias || element.fbp_criteria_type;
    //     });
    //     this.fetchAll_Employeeofficial();
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    //server call to get only category when u will get details of declared
    async fetchFBPcatagory() {
      try {
        let res = await this.act_getFbp_componentliost(this.leId);
        this.catagoryName = res.data.payload[0].fbp_criterias;
        //console.log(this.catagoryName);
        this.fetchRecord();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    loadEmployeeDocuments(res) {
      let documentList = [];
      //console.log(this.employeeDocs);
    },

    refresh() {
      try {
        this.showButtons =false;
        this.showErrorMsg = false;
        this.showErrorMsgs = false;
        this.showEmpDetails = false;
        this.fetchingBack = false;
        this.effectiveDate ="";
        this.specialAllowance = "";
        this.componentList = [];
        this.newArrayElementData = [];
        this.fbpCtcSlabscomponents =[];
        this.monthly_declaration_amount = [];
        this.is_employee_submitted =false
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    //submit when save button click
    submit() {
      //console.log("eneterd to Submit function");
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.performingAction();
          //console.log("i am v-model", this.monthly_declaration_amount);
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },

    /* server call to create FBP LOCK */
    async performingAction() {  
      try {
        console.log(this.componentList, 'comp');
        if (this.fetchingBack) {
          let date = new Date().getFullYear();
          //console.log("res >>>>>>>>>>>>>> ", date);
          let formData = {
            id: this.fetchedId,
            employee_id: this.empId,
            legal_entity_id: this.leId,
            fbp_year: date,
            slab_id: this.slabIdFetced,
            is_submitted: this.is_employee_submitted,
            declaration_details: this.componentList,
          };
          console.log(formData, '1');
          const res = await this.act_postFBP_declare(formData);
          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
          } else {
            this.toast = true;
          }
        } else {
          let date = new Date().getFullYear();
          //console.log("res >>>>>>>>>>>>>> ", date);
          let formDatas = {
            employee_id: this.empId,
            legal_entity_id: this.leId,
            fbp_year: date,
            slab_id: this.fbpSalaryId,
            is_submitted: this.is_employee_submitted,
            declaration_details: this.componentList,
          };
          console.log(formDatas, '2');
          const res = await this.act_postFBP_declare(formDatas);
          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
          } else {
            this.toast = true;
          }
        }
      } catch (error) {
        //console.log(error);
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to hide the success pop-up and go back to Designation main page */
    backFromPopUp() {
      this.showSuccessMsg = false;
      this.refresh();
    },

    /* server call to get FBPLOCK DETAILS */
    async fetchAllFbpLockDetails() {
      try {
        //adding the inputfiel

        // this.totol = this.monthly_declaration_amount.reduce((accumulator, value) => {
        // return accumulator + value;
        // }, 0);
        // //console.log("i am totol",totol)
        // ;
        let res = await this.act_getFbp_declare({
          le_id: this.leId,
          emp_id: this.empId,
        });
        this.is_employee_submitted =res.data.payload.is_employee_submitted
        if (res.data.payload.declaration_details) {
          this.fbpCtcSlabscomponents = [];
          (this.ctcAmount = ""), (this.showJoiningDate = ""), (this.unAllocatedFbp = "");
          this.fbpCtcSlabscomponentsandvalue = [];
          this.fbpCtcSlabscomponentsandvalue = res.data.payload.declaration_details;
          this.showJoiningDate = res.data.payload.date_of_joining;
          this.unAllocatedFbp = res.data.payload.unAllocatedFbp ? res.data.payload.unAllocatedFbp : "0" ;
            // const dateString = res.data.payload.date_of_joining;
            // const dateObject = new Date(dateString);
            // const day = dateObject.getDate().toString().padStart(2, '0');
            // const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
            // const year = dateObject.getFullYear();
            // this.showJoiningDate = `${day}/${month}/${year}`;
          this.ctcAmount = res.data.payload.revisionStructure ? res.data.payload.revisionStructure[res.data.payload.revisionStructure.length - 1].ctc : res.data.payload.ctc;
          this.specialAllowance = res.data.payload.FBP
          this.monthltSpecialAllowance = res.data.payload.revisionStructure ? res.data.payload.revisionStructure[res.data.payload.revisionStructure.length - 1].details.find(obj => obj.abbreviation === "SPL-ALW").monthly : res.data.payload.monthlySA;
          this.monthltSpecialAllowanceDeclared = res.data.payload.monthlySAafterFbpDeclared
          this.elementFbpComponentId = res.data.payload.slab_id;
          //console.log(res.data.payload)
          //console.log(this.elementFbpComponentId);
          this.fetchFBPcomponentlistonly_for_value();
          this.fetchedId = res.data.payload.id;
          this.slabIdFetced = res.data.payload.slab_id;
          this.fetchingBack = true;
          this.gettingNew = false;
          // res.data.payload.declaration_details.forEach((element) => {
          //   this.effectiveDate = element.effective_date
          // })
          if (res.data.payload.revisionStructure) {
            const dateString = res.data.payload.revisionStructure[res.data.payload.revisionStructure.length - 1].from;
            const [year, month, day] = dateString.split("-");
            this.effectiveDate = `${day}/${month}/${year}`;
          }
          else {
            const dateString = res.data.payload.date_of_joining;
            const [day, month, year] = dateString.split("/");
            this.effectiveDate = `${day}/${month}/${year}`;
          }

        } else {
          // this.fetchFBPcomponentlist();
          // //console.log(
          //   "i am inside the else condition",
          //   this.fbpCtcSlabscomponents
          // );
          this.showButtons = true
          this.fbpCtcSlabscomponents = [];
          (this.ctcAmount = ""), (this.showJoiningDate = ""), (this.unAllocatedFbp = "");
          res.data.payload.forEach((element) => {
            let eligibilityValue;
            if (element.calculation_type == "FLAT") {
              eligibilityValue = element.monthly_eligibilty;
            } else if (element.calculation_type == "PERCENTAGE_OF_BASIC") {
              eligibilityValue = element.monthly_eligibilty;
            } else {
            }
            (this.ctcAmount = element.ctc),
              (this.showJoiningDate = element.date_of_joining);
              this.unAllocatedFbp = res.data.payload.unAllocatedFbp ? res.data.payload.unAllocatedFbp : "0" ;
            const dateString = element.effective_date;
            const [day, month, year] = dateString.split("/");
            // const dateObject = new Date(dateString);
            // const day = dateObject.getDate().toString().padStart(2, '0');
            // const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
            // const year = dateObject.getFullYear();
            this.effectiveDate = `${day}/${month}/${year}`;

            this.specialAllowance = element.FBP,
              this.monthltSpecialAllowance = element.monthlySA,
              this.monthltSpecialAllowanceDeclared = element.monthlySAafterFbpDeclared
            this.fbpCtcSlabscomponents.push({
              salaryComponentLEName: element.SalaryComponentLegalEntity.name,
              value: Number(Math.round(eligibilityValue)),
              fbp_component_id: element.SalaryComponentLegalEntity.id,
              yearly_eligibility: element.yearly_eligibility,
              remainingMonth: element.remainingMonth,
              remainingDays: element.remainingDays,
              remainingMonth: element.remainingMonth,
              noOfDaysInMonth: element.noOfDaysInMonth,
              monthly_declaration_amount: 0,
              annual_declared_amount: 0,
              code: element.SalaryComponentLegalEntity.code,
              pay_type: element.SalaryComponentLegalEntity.pay_type
            });
          });
          this.gettingNew = true;
          this.fetchingBack = false;
          for (let salaryId of res.data.payload) {
            this.fbpSalaryId =
              salaryId.fbp_salary_grade_id ||
              salaryId.fbp_level_id ||
              salaryId.fbp_location_id ||
              salaryId.fbp_ctc_slab_id;
          }
        }
      } catch (error) {
        //console.log(error);
        this.toast = true;
        this.errmsg = error;
      }
    },

    async loadDocuments() {
      let res = await this.fetchEmployeeDocumentsByEmployeeId({
        data: { employee_id: this.empId },
      });
      this.employeeDocs = [];
      this.loadEmployeeDocuments(res);
      this.showUploadDocuments = !this.showUploadDocuments;
    },

    cancelEvent() {
      this.showSuccessMsg = false;
    },

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get locations */
    async getLocations() {
      try {
        let res = await this.act_fetch_locations(this.leId);
        this.subRepTypeOption = res.data.payload.data;
        this.locationIdOf = this.subRepTypeOption[0].id;
        //console.log("i am location", this.subRepTypeOption[0].id);
        //console.log("i am locationIdOf", this.locationIdOf);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.leId;
      //console.log("Org:", org);
      //console.log("Le ID", le);
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });

      this.role = data.data.user.userRole;
      this.companyValue = data.data.user.permissions.company ? true : false;
      //console.log(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  padding-left: 50px;
}
.custom {
  width: 180px;
}
.margin-bot-22 {
  margin-bottom: 22px;
}
.block-width {
  display: inline-table;
}
.show-filter-text {
  margin-left: 5%;
  font-weight: bold;
  color: #37c6c0;
}
.end {
  justify-content: flex-end;
}
.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}
.document-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.cross-circle-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.add-plus-icon {
  opacity: 0.5;
  // display: none;
  &:hover {
    // display: block;
    opacity: 0.7;
    cursor: pointer;
  }
}

.document-counts {
  display: inline-block;
  font-weight: bold;
  margin: 0 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
}

tr.record-row:hover {
  background: #ebf9f8;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}

.head {
  margin-top: 37px;
}
.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}
.lock-list {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
}

.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}
.checkbox {
  margin: 30px 0px 0px 2px;
}
.formbutton {
  color: blue;
}
.type {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  div {
    width: 250px;
    padding-right: 20px;
    margin-top: 15px;
  }
}
.employeeCard {
  background-color: #f0f1f5;
  display: flex;
}
.employeeImage {
  height: 8rem;
  width: 8rem;
  margin: 20px;
}
.employeeDetails {
  margin: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.empDetails {
  background-color: white;
  width: 18rem;
  height: 5rem;
  border-radius: 6px;
  box-shadow: #e5e7f8 2px 4px 3px;
}
.empContentdev {
  padding: 11px 11px;
  position: relative;
}
.empContent {
  margin-bottom:5px;
  font-size: 12px;
}
.rowOneContent {
  display: flex;
  gap: 12px;
}
.close-card {
  position: relative;
  cursor: pointer;
  color: #5d409f;
  margin:8px 0px 13px 46rem;
}
.cancel{
  font-size:26px;
  font-weight:500;
}

.tooltip {
  position: absolute;
  top: 32px;
  right: 5px;
  margin-top: 5px; /* Adjust the margin as needed */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 750px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 110%;
  left: -75px; /* Adjusted to center the tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.tooltip::after {
  content: "ℹ️";
  position: absolute;
  top: 55%;
  right: 0;
  transform: translateY(-50%);
}

</style>
